import React from "react";
import { splitActionItemsSourceLabel } from "../actionItemHelpers";

/**
 * Meeting-time chip that nests one small removable pill per contributing source
 * (Granola, Zoom, ...) instead of spawning separate sibling chips. The chip's own
 * × clears the whole meeting filter; each nested pill's × drops just that source.
 *
 * @example
 * <ActionItemsMeetingFilterChip
 *   label="Tue, Jul 7 · 10:44 AM"
 *   sources={[{ id: "wf-granola", name: "Granola - sam@co.com" }, { id: "wf-zoom", name: "Zoom - sam@co.com" }]}
 *   onRemoveAll={() => {}}
 *   onRemoveSource={(id) => {}}
 * />
 * // Output — "Tue, Jul 7 · 10:44 AM" with "Granola ×" and "Zoom ×" pills underneath
 */
const ActionItemsMeetingFilterChip = ({
  label,
  sources = [],
  onRemoveAll,
  onRemoveSource,
  className = "",
}) => (
  <div
    className={["action-items-active-filter", className].filter(Boolean).join(" ")}
    role="status"
    aria-live="polite"
  >
    <button
      type="button"
      className="action-items-active-filter__clear"
      onClick={onRemoveAll}
      aria-label={`Remove ${label} meeting filter`}
      title={`Remove ${label} meeting filter`}
    >
      ×
    </button>
    <span className="action-items-active-filter__text">
      <span className="action-items-active-filter__label">{label}</span>
      <span className="action-items-active-filter__meeting-sources">
        {sources.map((source) => {
          const { main } = splitActionItemsSourceLabel(source.name);
          return (
            <span key={source.id} className="action-items-active-filter__meeting-source">
              {main}
              <button
                type="button"
                className="action-items-active-filter__meeting-source-remove"
                onClick={() => onRemoveSource(source.id)}
                aria-label={`Remove ${main} from this meeting's tasks`}
                title={`Remove ${main} from this meeting's tasks`}
              >
                ×
              </button>
            </span>
          );
        })}
      </span>
    </span>
  </div>
);

export default ActionItemsMeetingFilterChip;
